import { UserDetails, UserStatuses } from '../types';

const filtersHelper = (
  items: UserDetails[],
  filters: {
    roleId: string;
    search: string;
    onlyArchived: boolean;
  },
  selectedRoles?: string[],
): UserDetails[] => {
  let nextItems: UserDetails[] = items;

  Object.keys(filters).map((fieldName) => {
    nextItems = nextItems?.filter((item) => {
      let value;

      if (fieldName === 'onlyArchived' && filters.onlyArchived) {
        value = item.status === UserStatuses.DISABLED;
      } else if (fieldName === 'search' && filters.search) {
        value =
          item.profile.firstName
            .toLowerCase()
            .includes(filters.search.toLowerCase()) ||
          item.profile.lastName
            .toLowerCase()
            .includes(filters.search.toLowerCase());
      } else {
        return true;
      }

      return value;
    });

    return nextItems;
  });

  if (selectedRoles?.length) {
    const filteredArray: UserDetails[] = [];

    nextItems.forEach((item) => {
      if (selectedRoles?.find((role) => item.employeeRoleTemplateId === role)) {
        filteredArray.push(item);
      }
    });

    nextItems = filteredArray;
  }

  return nextItems;
};

export default filtersHelper;
